/* eslint-disable */
import { Button } from "@chakra-ui/react";
import React from "react";

interface SelectAllButtonProps {
  onClick: any;
}

const SelectAllButton: React.FC<SelectAllButtonProps> = (props: any) => {
  return (
    <Button
      variant="outlined"
      size="small"
      color="primary"
      id={props.name}
      onClick={() => {
        props.onClick();
      }}
    >
      ALL
    </Button>
  );
};

export default SelectAllButton;
